import classNames from 'classnames/bind';
import styles from '@/styles/superstack/base/Radio.module.scss';
import PropTypes from 'prop-types';
import IconRadioChecked from '@/asset/superstack/svgs/icon-radio-checked.svg';
import IconRadio from '@/asset/superstack/svgs/icon-radio-normal.svg';

const Radio = ({ size, name, value, checked, disabled, updateContainer, ...props }) => {
  const cx = classNames.bind(styles);
  const cns = disabled ? [`label--${size}`, 'label--disabled'] : [`label--${size}`];
  const iconSize = size === 'lg' ? 24 : 16;

  const handleChecked = (e) => {
    if (updateContainer) {
      updateContainer(e);
    }
  };

  return (
    <label htmlFor={value} className={cx(cns)} {...props}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        id={value}
        className={cx('input')}
        onChange={handleChecked}
        disabled={disabled}
      />
      <div className={cx(['input-display', 'checked'])} style={{ height: iconSize }}>
        <IconRadioChecked width={iconSize} height={iconSize} />
      </div>
      <div className={cx(['input-display', 'unchecked'])} style={{ height: iconSize }}>
        <IconRadio width={iconSize} height={iconSize} />
      </div>
      {props.children}
    </label>
  );
};

const ChipRadio = ({
  mode = 'label',
  name,
  value,
  checked,
  disabled,
  updateContainer,
  borderColor = '#89D0B9',
  bgColor = '#ffffff',
  ...props
}) => {
  const cx = classNames.bind(styles);
  let cns;
  if (mode === 'panel') {
    cns = disabled ? ['panel--chip', 'panel--disabled'] : ['panel--chip'];
  } else {
    cns = disabled ? ['label--chip', 'label--disabled'] : ['label--chip'];
  }

  const handleChecked = (e) => {
    if (updateContainer) {
      updateContainer(e);
    }
  };

  return (
    <label htmlFor={value} className={cx(cns)} {...props}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        id={value}
        className={cx('input')}
        onChange={handleChecked}
        disabled={disabled}
      />
      <div
        className={cx(['input-display', checked ? 'checked' : 'unchecked'])}
        style={{ border: checked ? `1px solid ${borderColor}` : 'none', backgroundColor: bgColor }}
      >
        {props.children}
      </div>
    </label>
  );
};

Radio.prototype = {
  size: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.string,
  disabled: PropTypes.string,
};
Radio.defaultProps = {
  size: 'lg',
  name: 'test',
  checked: false,
  disabled: false,
};

export { Radio, ChipRadio };
